import FooterLink from './FooterLink';

// `desktopOnly` hides the footer below md — used on the signed-in pages, where
// the small screen is better spent on content. Public pages keep it everywhere.
function Footer({ desktopOnly = false }) {
  return (
    <footer
      className={`bg-background-light dark:bg-background-dark border-t border-gray-200 dark:border-gray-800 ${
        desktopOnly ? 'hidden md:block' : ''
      }`}
    >
      <div className="container mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            © 2026 Dissona. All rights reserved.
          </p>
          {/* wraps: five links, one of them long, do not fit a narrow screen */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <FooterLink to="/docs">Docs</FooterLink>
            <FooterLink to="/extensions">Browser extensions</FooterLink>
            <FooterLink to="/terms">Terms</FooterLink>
            <FooterLink to="/privacy">Privacy</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
